import httpClient from "../axios/interceptors";
import { AxiosResponse } from "axios";
import { API } from "./endpoint";

export type SpeedAddress = {
  county: string;
  city: string;
  state: string;
  postcode: string;
};

export type CheckPriceInput = {
  box_width: number;
  box_height: number;
  box_length: number;
  box_weight: number;
  // optional: backend จะ default เป็น "ALL" (whitelist pipe จะตัด field ที่ไม่รองรับอยู่แล้ว)
  carrier_code?: string;
  origin: SpeedAddress;
  destination: SpeedAddress;
  cod_amount?: number;
};

export type CheckPriceCarrierItem = {
  carrier?: string;
  carrier_code?: string;
  logo?: string;
  remote_price?: string | number;
  tourism_price?: string | number;
  island_price?: string | number;
  price?: string | number;
  total?: string | number;
  is_pickup?: number;
  delivery_time?: string;
  name?: string;
  minimum_time?: number;
  maximum_time?: number;
  partner_id: string;
  brand_id: string;
  /** ชื่อตรง DB */
  api_transport_price?: number;
  add_on_api_transport_price?: number;
  transport_price?: number;
  /** alias เดิม */
  add_on_price?: number;
  total_with_add_on?: number;
  [key: string]: any;
};



export type CheckPriceResponse = {
  status?: string;
  data?: CheckPriceCarrierItem[];
  request_id?: string;
  [key: string]: any;
};

/** แปลง response check-price ให้เป็น array เสมอ (BE คืน array ตรง หรือห่อใน { data }) */
export function normalizeCheckPriceCarrierList(payload: unknown): CheckPriceCarrierItem[] {
  if (Array.isArray(payload)) {
    return payload as CheckPriceCarrierItem[];
  }
  if (payload && typeof payload === "object") {
    const record = payload as Record<string, unknown>;
    const nested = record.data;
    if (Array.isArray(nested)) {
      return nested as CheckPriceCarrierItem[];
    }
    if (nested && typeof nested === "object" && !Array.isArray(nested)) {
      return [nested as CheckPriceCarrierItem];
    }
    if (record.carrier_code != null || record.carrier != null) {
      return [payload as CheckPriceCarrierItem];
    }
  }
  return [];
}

export const checkSpeedShippingPrice = async (
  input: CheckPriceInput
): Promise<CheckPriceResponse> => {
  const res: AxiosResponse<unknown> = await httpClient.post(API.apiSpeedCheckPrice, input);
  const body = res.data;
  const list = normalizeCheckPriceCarrierList(body);
  const requestId =
    body && typeof body === "object" && !Array.isArray(body)
      ? (body as Record<string, unknown>).request_id
      : undefined;
  return {
    status: "success",
    data: list,
    ...(requestId != null ? { request_id: String(requestId) } : {}),
  };
};



export type SpeedShippingConfigResponse = {
  status?: string;
  data?: {
    origin?: {
      sub_district?: string;
      district?: string;
      province?: string;
      zip_code?: string;
    },
    destination?: {
      north?: SpeedAddress;
      south?: SpeedAddress;
    }
  }
};

export const getSpeedShippingConfig = async (): Promise<SpeedShippingConfigResponse> => {
  const res: AxiosResponse<any> = await httpClient.get(API.apiSpeedCheckPriceConfig);
  return res.data;
};
